import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LiquidGlassCircleButton } from '../common/LiquidGlassCircleButton';

interface VoiceExpandMenuCategoryProps {
  onNewCategory: () => void;
}

export const VoiceExpandMenuCategory: FC<VoiceExpandMenuCategoryProps> = ({
  onNewCategory,
}) => {
  const { t } = useTranslation();
  return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', width: '100%' }}>
    <Text weight="2" style={{ fontSize: 16, color: 'var(--tg-theme-text-color)' }}>
      {t('category.new')}
    </Text>
    <LiquidGlassCircleButton icon="category" ariaLabel={t('category.new')} onClick={onNewCategory} />
  </Box>;
};
